import React from "react";
import { BCMSDate, Workflow, useBCMSContext, BCMSRecord } from "bcms-react";
import Classes, { Account, CompanyAccount, OneTimeACHPayment, Participant } from "model";

import OneTimeWirePage from "components/pages/OneTimeWirePage";
// Steps of the workflow
const steps = [ <OneTimeWirePage /> ];

/**
 * @function OneTimeWireTransferWorkflow
 * @returns {React.Component}
 * @exported true
 * @description The main workflow component for the wire transfer workflow.
 * @example
 * <OneTimeWireTransferWorkflow />
 */
export default function OneTimeWireTransferWorkflow(props) {
    const context = useBCMSContext();
    BCMSRecord.globalControllerFor(Classes, context);

    const value = getDefaultData();
    return <Workflow value={ value } steps={ steps } />
}

/**
 * @function getWorkflowSteps
 * @returns {ARRAY}
 * @exported true
 * @description Hook to return the steps of the workflow
 */
export const getWorkflowSteps = () => steps;

/**
 * @function getDefaultData
 * @returns {OBJECT}
 * @exported true
 * @description Hook to return the default state of the workflow
 */
export const getDefaultData = () => ({
    
});